import * as BABYLON from '@babylonjs/core';
import Models from './Models';
import ModelFile from './ModelFile';
import BabylonModel from './BabylonModel';
import ParameterErrors from '../errors/ParameterErrors';
import UrlHelper from '../core/UrlHelper';
import '@babylonjs/loaders'
const { throwNotProvided, throwNotOfType } = ParameterErrors;
BABYLON.SceneLoader.loggingLevel = BABYLON.SceneLoader.DETAILED_LOGGING;
export default class BabylonModelsManagerCache {
    constructor(props) { 
		this._mapFileNameToBabylonModel = new Map();
    }
	add(filePath, babylonModel){
		this._mapFileNameToBabylonModel.set(filePath, babylonModel);
	}
	has(filePath){
		return this._mapFileNameToBabylonModel.has(filePath);
	}
	get(filePath){
		return this._mapFileNameToBabylonModel.get(filePath);
	}
}